import React from 'react';
import { View, StyleSheet, Text, Image, Switch } from 'react-native';
import {
  I18n,
  Utils,
  Container,
  FormInput,
  FormFooter,
  FormHelpers,
  Select,
  DateUtils,
  OPPureComponent,
} from '..';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';

import moment from 'moment';

import Days from './day_select';
import SelectSchedule from './select_schedule';

function times(start) {
  const startMoment = moment().startOf('day');
  if (start) {
    startMoment.hours(parseInt(start.split(':')[0]));
    startMoment.minutes(parseInt(start.split(':')[1]));
    startMoment.add(15, 'minutes');
  }
  const retArray = [];
  let i;
  for (i = 0; i < 24 * 4; i++) {
    retArray.push(`${DateUtils.pad(startMoment.hours())}:${DateUtils.pad(startMoment.minutes())}`);
    startMoment.add(15, 'minutes');
  }
  return retArray;
}

function closingTimeOptions(start = '00:00') {
  const startHours = parseInt(start.split(':')[0]);
  const startMinutes = parseInt(start.split(':')[1]);
  return times(start).map((id) => {
    const currentHours = parseInt(id.split(':')[0]);
    const currentMinutes = parseInt(id.split(':')[1]);
    const nextDay =
      currentHours < startHours || (currentHours === startHours && currentMinutes <= startMinutes);
    return { label: `${id}${nextDay ? ' Next day' : ''}`, id };
  });
}

class Shift extends OPPureComponent {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };
  }

  handleStartTime = ({ id }) => {
    this.props.onChange({
      shift: {
        ...this.props.shift,
        opening_time: id,
      },
      i: this.props.i,
    });
  };

  handleEndTime = ({ id }) => {
    this.props.onChange({
      shift: {
        ...this.props.shift,
        ending_time: id,
      },
      i: this.props.i,
    });
  };

  handleSelectFocus = () => {
    this.setState({ focused: true });
  };

  handleLunchChange = (lunch) => {
    this.props.onChange({
      shift: {
        ...this.props.shift,
        lunch_break: !lunch,
      },
      i: this.props.i,
    });
  };

  render() {
    const shift = this.props.shift;
    const multiple = this.props.multiple;
    const width = multiple ? 200 : '100%';
    const lunch = shift.lunch_break !== false;
    return (
      <View>
        <View
          style={[multiple ? THEME.basicRow : null, this.state.focused ? { zIndex: 1000 } : null]}
        >
          <Select
            required={true}
            editable={true}
            closeOnSelect={true}
            onFocus={this.handleSelectFocus}
            options={times().map((id) => ({ label: id, id }))}
            label={'Opening Time'}
            value={{ label: shift.opening_time, id: shift.opening_time }}
            onValue={this.handleStartTime}
            webMode={true}
            containerStyle={{ width }}
          />
          <Select
            required={true}
            editable={true}
            closeOnSelect={true}
            onFocus={this.handleSelectFocus}
            options={closingTimeOptions(shift.opening_time)}
            label={'Closing Time'}
            value={{
              label: DateUtils.endTimeLabel(shift.opening_time, shift.ending_time),
              id: shift.ending_time,
            }}
            onValue={this.handleEndTime}
            webMode={true}
            containerStyle={{ width }}
          />
        </View>

        <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 25 }}>
          <Text style={[styles.lunchText, lunch ? styles.lunchTextSelected : null]}>
            Lunch Break
          </Text>
          <Switch
            value={!lunch}
            onValueChange={this.handleLunchChange}
            thumbColor={'#FFF'}
            activeThumbColor={'#FFF'}
            trackColor={'#939393'}
            activeTrackColor={'#939393'}
          />
          <Text style={[styles.lunchText, !lunch ? styles.lunchTextSelected : null]}>
            No Lunch Break
          </Text>
        </View>
      </View>
    );
  }
}

export default class ShiftScheduleForm extends OPPureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedDays: {},
      selectedSchedule: null,
      shifts: [{}],
      numShifts: 1,
    };
  }

  scheduleOptionLabel = (s) => {
    return `${DateUtils.daysOfWeekLabel(s.days)} (${s.hours[0].opening_time} - ${
      s.hours[0].ending_time
    })`;
  };

  componentDidMount() {
    const props = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const props = this.props;
  }

  shiftData() {
    const selectedDays = this.state.selectedDays;
    const shifts = this.state.shifts;
    const days = Object.keys(selectedDays)
      .filter((day) => !!selectedDays[day])
      .map((d) => parseInt(d));

    const data = {
      shifts: days.reduce((result, day) => {
        shifts.forEach((shift) => {
          result.push({
            ...shift,
            day,
          });
        });
        if (!shifts?.length) {
          result.push({ day });
        }
        return result;
      }, []),
      scheduleId: this.state.selectedScheduleId,
    };

    const newScheduleKey = days.sort().join();
    this._newScheduleKey = newScheduleKey;

    return data;
  }

  enableSave = () => {
    const days = Object.keys(this.state.selectedDays)
      .filter((day) => !!this.state.selectedDays[day])
      .map((d) => parseInt(d));
    const canSave =
      (days.length || !!this.state.selectedScheduleId) &&
      this.state.shifts?.[0]?.opening_time &&
      this.state.shifts?.[0]?.ending_time;
    this.props.onDataChange({ canSave });
  };

  handleDayPress = (i) => {
    const selectedDays = {
      ...this.state.selectedDays,
      [i]: !this.state.selectedDays?.[i],
    };
    this.setState({ selectedDays }, this.enableSave);
  };

  handleShiftChange = ({ shift, i }) => {
    const shifts = this.state.shifts.slice();
    if (shifts.length > i) {
      shifts[i] = {
        ...shift,
        lunch_break: shift.lunch_break !== false,
      };
    } else {
      shifts.push({ ...shift });
    }
    this.setState({ shifts }, this.enableSave);
  };

  renderShift = (s, i) => {
    const shift = this.state.shifts[i];

    return (
      <Shift
        key={i}
        multiple={this.props.multiple}
        i={i}
        shift={{ ...shift }}
        onChange={this.handleShiftChange}
      />
    );
  };

  handleSelectSchedule = ({ selectedSchedule, selectedDays }) => {
    const props = this.props;
    const state = this.state;
    this.setState({
      selectedSchedule,
      shifts: selectedSchedule?.hours || [{}],
      selectedDays,
    });

    this.props.onDataChange({ canSave: false });
  };

  render() {
    const props = this.props;
    const days = Object.keys(this.state.selectedDays)
      .filter((day) => !!this.state.selectedDays[day])
      .map((d) => parseInt(d));
    const nextScheduleId = days.join();
    return (
      <Container>
        <View style={{ zIndex: 1000, paddingHorizontal: 35, paddingTop: 15 }}>
          <SelectSchedule
            schedules={props.schedules}
            onSelectSchedule={this.handleSelectSchedule}
            nextScheduleId={nextScheduleId}
            scheduleOptionLabel={this.scheduleOptionLabel}
          />
        </View>

        <Days onPressDay={this.handleDayPress} selectedDays={this.state.selectedDays} />

        <View
          style={[
            { paddingHorizontal: 35, paddingVertical: 40, zIndex: 1000, alignItems: 'center' },
          ]}
        >
          {/*renderSelect('numSel', props.numOptions, 'Number of Shifts', num, num, handleChangeNum)*/}

          {Array(this.state.numShifts).fill().map(this.renderShift)}
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  formInputs: {
    width: '100%',
    justifyContent: 'center',
  },
  containerContent: {
    paddingTop: 25,
  },
  lunchText: {
    ...FONT.medium,
    fontSize: 18,
    color: 'rgb(165,165,159)',
    paddingHorizontal: 20,
  },
  lunchTextSelected: {
    ...FONT.bold,
    fontSize: 18,
    color: 'rgb(29,29,37)',
  },
});
